import type { FitThesis } from '@ispot/shared'

interface Props {
  theses: FitThesis[]
  totalPairs: number
}

/**
 * Page-level portfolio rollup. Surfaces "where the work is" before the user
 * even scans rows: how many theses are validated, in motion, or untouched.
 */
export function FitThesisPortfolioBar({ theses, totalPairs }: Props) {
  let validated = 0
  let inProgress = 0
  for (const t of theses) {
    if (t.status === 'validated' || t.status === 'complete') validated += 1
    else if (t.status === 'draft' || t.status === 'gap') inProgress += 1
  }
  const notStarted = Math.max(0, totalPairs - validated - inProgress)

  return (
    <div className="flex flex-wrap items-center gap-x-7 gap-y-2 pb-5 pt-1">
      <span className="font-mono text-[11px] font-semibold uppercase tracking-wider text-fg-muted">
        Portfolio
      </span>
      <Stat color="var(--color-success-fg)" value={validated} label="validated" />
      <Stat color="var(--color-warning-fg)" value={inProgress} label="in progress" />
      <Stat color="var(--color-fg-muted)" value={notStarted} label="not started" />
    </div>
  )
}

function Stat({ color, value, label }: { color: string; value: number; label: string }) {
  return (
    <span className="inline-flex items-center gap-1.5 text-caption text-fg">
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: color }} />
      <strong className="font-semibold">{value}</strong> {label}
    </span>
  )
}
